<div class="ziti-page-container ziti-services-container lt-skin-page">
  <lib-list-table-header
    [title]="title"
    subtitle="Manage the services identities can dial and host on your network"
    createLabel="Create Service"
    infoText="Services define what identities can reach, and the configs that describe how to reach it."
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
    (actionClicked)="headerActionClicked($event)"
  >
    <span header-icon class="icon-services" aria-hidden="true"></span>
  </lib-list-table-header>
  <ng-content select="[slot=list-page-subheader]"></ng-content>
  <lib-list-table class="lt-skin" [tableId]="tableId" [initialPageSize]="initialPageSize"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columns]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    [headerActions]="svc.tableHeaderActions"
    [noItemsImage]="'No_Clients'"
    (tableReady)="tableReady($event)"
    >
  </lib-list-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
